<template>
  <detail-template :classCustom="'detail-docs'">
    <template #content>
      <div
        class="back-icon border-radius__50 clickable flex-row flex__center"
        @click="backListPage()"
      >
        <i class="el-icon-back font-size__large"></i>
      </div>

      <div class="header">
        <div class="docTags">
          <hc-maybay-state
            v-if="hcFlowInstance"
            :state="hcFlowInstance.currentStateCode"
          />
        </div>
      </div>

      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <div
            style="color: #007aff"
            class="font-size__large font-weight__bold margin-top-10 margin-bottom-10"
          >
            Yêu cầu đặt phòng họp
          </div>
          <div class="margin-top-10" v-if="!!requestUserDeptRole">
            <span class="label-input">Đơn vị yêu cầu:</span>
            <span class="font-weight__bold">{{
              requestUserDeptRole.deptName
            }}</span>
          </div>
          <div
            class="margin-top-10 padding-bottom-10 flex-row has-border__bottom"
            v-if="hcCasePhonghop && requestUserDeptRole"
          >
            <span class="label-input">Người yêu cầu:</span>
            <div class="flex-row flex__left margin-left-10">
              <span class="font-weight__bold">{{
                requestUserDeptRole.fullName
              }}</span>
            </div>
            <span class="label-input margin-left-10">vào lúc:</span>
            <div class="flex-row flex__left margin-left-10">
              <span class="font-weight__bold">
                {{
                  hcCasePhonghop.createTime | dateFormatter({ nullValue: "-" })
                }}
              </span>
            </div>
          </div>

          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            inline-message
            label-width="150px"
          >
            <div class="group__info margin-top-10">
              <div class="content">
                <div class="form-input">
                  <div
                    class="title font-size__small font-weight__bold margin-bottom-10"
                  >
                    Thông tin yêu cầu
                  </div>

                  <el-row :gutter="24">
                    <el-col :span="24" class="margin-bottom-10">
                      <el-form-item label="Tiêu đề" prop="meetingTitle">
                        <el-input
                          v-model="form.meetingTitle"
                          placeholder="Tiêu đề"
                          class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold input-count__bottom"
                          size="medium"
                          maxlength="100"
                          show-word-limit
                          :autosize="{ minRows: 2, maxRows: 5 }"
                          :readonly="true"
                        ></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24" class="margin-bottom-10">
                      <el-form-item
                        label="Nội dung cuộc họp"
                        prop="meetingContent"
                      >
                        <el-input
                          type="textarea"
                          v-model="form.meetingContent"
                          placeholder="Nội dung cuộc họp"
                          class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold input-count__bottom"
                          size="medium"
                          maxlength="500"
                          show-word-limit
                          :autosize="{ minRows: 2, maxRows: 5 }"
                          :readonly="approve === null"
                        ></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="16">
                      <el-form-item label="Thời gian bắt đầu" prop="startTime">
                        <el-date-picker
                          v-model="form.startTime"
                          size="medium"
                          class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                          type="datetime"
                          placeholder="dd/MM/yyyy HH:mm"
                          format="dd/MM/yyyy HH:mm"
                          :prefix-icon="' '"
                          :readonly="!update"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>

                    <el-col :span="16">
                      <el-form-item label="Thời gian kết thúc" prop="endTime">
                        <el-date-picker
                          v-model="form.endTime"
                          size="medium"
                          class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                          type="datetime"
                          placeholder="dd/MM/yyyy HH:mm"
                          format="dd/MM/yyyy HH:mm"
                          :prefix-icon="' '"
                          :readonly="!update"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item prop="sendSMS" label="Gửi SMS">
                        <el-checkbox :disabled="!update" v-model="form.sendSMS"
                          >Gửi nội dung tiêu đề đến điện thoại người
                          dùng</el-checkbox
                        >
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item prop="sendEmail" label="Gửi Email">
                        <el-checkbox
                          :disabled="!update"
                          v-model="form.sendEmail"
                          >Gửi nội dung tiêu đề đến Email người
                          dùng</el-checkbox
                        >
                      </el-form-item>
                    </el-col>

                    <el-col
                      :span="24"
                      v-if="involedUsers && involedUsers.length"
                    >
                      <el-form-item
                        label="Thành phần tham dự"
                        prop="otherInvolved"
                      >
                        <div class="has-border__bottom">
                          <template v-for="item in involedUsers">
                            <div class="style-fullWidth" :key="item.id">
                              <!-- :maxLength="50" -->
                              <break-word-span
                                :text="getActorLabel(item)"
                                class="font-weight__bold readonly-field"
                              ></break-word-span>
                            </div>
                          </template>
                        </div>
                        <!--                          </el-col>-->
                        <!--                        </el-row>-->
                      </el-form-item>
                    </el-col>

                    <el-col :span="24" class="margin-bottom-10">
                      <el-form-item
                        label="Số lượng tham dự"
                        prop="otherInvolved"
                        :readonly="!update"
                      >
                        <el-input
                          type="textarea"
                          v-model="form.otherInvolved"
                          placeholder="Số lượng tham dự"
                          class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold input-count__bottom"
                          size="medium"
                          maxlength="500"
                          show-word-limit
                          :autosize="{ minRows: 2, maxRows: 5 }"
                          :readonly="!update"
                        ></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :span="16">
                      <el-form-item label="Độ quan trọng" prop="criticalLevel">
                        <hc-phonghop-critical-level-tag
                          :criticalLevel="form.criticalLevel"
                        ></hc-phonghop-critical-level-tag>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item label="Dịch vụ chuẩn bị" prop="services">
                        <el-checkbox-group
                          v-model="form.services"
                          class="width__100 checkbox-dich-vu"
                          :disabled="!update"
                        >
                          <el-checkbox
                            v-for="item in serviceOptions"
                            :key="item.value"
                            :label="item.value"
                            >{{ item.name }}
                          </el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24">
                      <el-form-item label="Phòng họp" prop="roomId">
                        <el-select
                          v-if="update || approve"
                          class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold"
                          v-model="form.roomId"
                          placeholder="Phòng họp"
                          size="medium"
                          filterable
                          clearable
                        >
                          <el-option
                            v-for="item in listRooms"
                            :key="item.id"
                            :label="item.roomName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                        <div v-else class="has-border__bottom">
                          <div class="style-fullWidth">
                            <break-word-span
                              :text="
                                hcCfgMeetingRoom
                                  ? hcCfgMeetingRoom.roomName
                                  : 'Không có'
                              "
                              :maxLength="50"
                              class="font-weight__bold readonly-field"
                            ></break-word-span>
                          </div>
                        </div>
                      </el-form-item>
                    </el-col>

                    <el-col :span="24" class="margin-bottom-10">
                      <el-form-item label="Ghi chú" prop="note">
                        <el-input
                          type="textarea"
                          v-model="form.note"
                          placeholder="Ghi chú"
                          class="input-border__bottom input-border__radius__0 style-fullWidth input-font__bold input-count__bottom"
                          size="medium"
                          maxlength="500"
                          show-word-limit
                          :autosize="{ minRows: 2, maxRows: 5 }"
                          :readonly="!approve && !update && !cancel"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </VuePerfectScrollbar>
      <div class="footer" v-if="!!approve || !!decline || !!update || !!cancel">
        <div class="flex-row flex__between">
          <div class="flex-row flex__left form-button__action">
            <el-button
              size="mini"
              class="addDocs color__blue btn-none__border"
              v-if="approve !== null"
              @click="approveRequest"
            >
              <i class="fas fa-arrow-circle-right font-size__small"></i>
              &nbsp;Phê duyệt
            </el-button>
            <el-button
              size="mini"
              class="addDocs color__red btn-none__border"
              v-if="decline !== null"
              @click="declineRequest()"
            >
              <i class="fas fa-times-circle font-size__small"></i>
              &nbsp;Từ chối
            </el-button>
            <el-button
              size="mini"
              class="addDocs color__blue btn-none__border"
              v-if="update !== null"
              @click="updateRoom"
            >
              <i class="font-size__small fas fa-pencil-alt"></i>
              &nbsp;Cập nhật
            </el-button>
            <el-button
              size="mini"
              class="addDocs color__red btn-none__border"
              v-if="cancel !== null && approve === null"
              @click="cancelRequest()"
            >
              <i class="fas fa-times-circle font-size__small"></i>
              &nbsp;Hủy yêu cầu
            </el-button>
          </div>
        </div>
      </div>
    </template>
  </detail-template>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import constants from "../../../constants";
import dateFormatter from "../../../filters/dateFormatter";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import goBackMixin from "../../../mixins/goBackMixin";
import h from "../../../services/h";
import hanhchinhService from "../../../services/hanhchinhService";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import hcCaseMasterService from "../../../services/hcCaseMasterService";
import hcCfgMeetingRoomService from "../../../services/hcCfgMeetingRoomService";
import hcFlowInstanceService from "../../../services/hcFlowInstanceService";
import hcFlowService from "../../../services/hcFlowService";
import hcStateToStateService from "../../../services/hcStateToStateService";
import hcCasePhongHopService from "../../../services/phonghop/hcCasePhongHopService";
import hcCasePhongHopUserService from "../../../services/phonghop/hcCasePhongHopUserService";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import utils from "../../../services/utils";
import DetailTemplate from "../../common/detail";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import HcPhonghopCriticalLevelTag from "../dieuxe/hc-phonghop-critical-level-tag";
import BreakWordSpan from "../ketluan/break-word-span";
import HcMaybayState from "../khachsan/hc-maybay-state";

export default {
  name: "hc-phonghop-detail",
  mixins: [handleRequestErrorMixin, goBackMixin],
  filters: { dateFormatter },
  components: {
    HcPhonghopCriticalLevelTag,
    BreakWordSpan,
    DetailTemplate,
    HcMaybayState,
    VuePerfectScrollbar,
  },

  data() {
    return {
      serviceOptions: null,
      involedUsers: [],
      // isRemoteSearchInvoledUsers: false,
      hcCasePhonghop: null,
      hcFlow: null,
      hcCaseMaster: null,
      hcFlowInstance: null,
      requestUserDeptRole: null,
      hcCasePhongHopUsers: null,
      listRooms: [],

      actions: [],
      approve: null,
      decline: null,
      cancel: null,
      update: null,

      form: {
        meetingTitle: null,
        meetingContent: null,
        startTime: null,
        endTime: null,
        otherInvolved: null,
        criticalLevel: null,
        services: [],
        involedUserIds: null,
        roomId: null,
        note: null,
        sendSMS: false,
        sendEmail: false,
      },
      rules: {
        meetingTitle: null,
        meetingContent: null,
        startTime: null,
        endTime: null,
        otherInvolved: null,
        criticalLevel: null,
        services: [],
        involedUserIds: null,
        roomId: null,
        note: null,
      },
      otherInvolvedLabel: null,
      hcCfgMeetingRoom: null,
    };
  },

  computed: {
    caseMasterId() {
      return this.$route.params.id;
    },

    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    isApprover() {
      return (
        this.userDeptRole.roleCode ===
          constants.ROLE.CODE.PHONG_HOP.QL_PHONG_HOP ||
        this.userDeptRole.roleCode ===
          constants.ROLE.CODE.HANH_CHINH.QL_HANH_CHINH
      );
    },

    isRequester() {
      return hanhChinhUtils.isRequester(this.userDeptRole, this.hcCasePhonghop);
    },
  },

  watch: {
    caseMasterId() {
      this.initPage();
    },
  },

  created() {
    // this.getData();
    // this.getAction();
    this.rules.note = [utils.buildRequiredValidationConstrains()];
    this.initSelectOptions();
    this.initPage();
  },

  methods: {
    async initPage() {
      await this.loadHcCasePhongHop();
      await this.loadHcCaseMaster();
      await this.loadHcFlowInstance();
      await this.loadHcFlow();
      await this.loadRequestUserDeptRole();
      await this.loadHcCasePhongHopUsers();
      await this.loadHcCfgMeetingRoom();
      await this.loadFreeRooms(
        this.hcCasePhonghop.startTime,
        this.hcCasePhonghop.endTime
      );
      await this.getAction();
      this.initFormForEdit();
      this.initOtherInvolvedLabel();
    },

    loadHcCfgMeetingRoom() {
      return (this.hcCasePhonghop.roomId
        ? hcCfgMeetingRoomService
            .findById(this.hcCasePhonghop.roomId)
            .then((response) => response.data)
        : Promise.resolve(null)
      ).then((hcCfgMeetingRoom) => (this.hcCfgMeetingRoom = hcCfgMeetingRoom));
    },

    initOtherInvolvedLabel() {
      this.otherInvolvedLabel = (
        h.collect(this.involedUsers, (item) => this.getActorLabel(item)) || []
      ).join("\n");
    },

    loadHcFlow() {
      return hcFlowService
        .findById(this.hcFlowInstance.flowId)
        .then((response) => (this.hcFlow = response.data));
    },

    initValidationRules(actionCode) {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur",
      };
      switch (actionCode) {
        case constants.HC_STATE_TO_STATE.ACTION_CODE.PHONG_HOP.HUY:
        case constants.HC_STATE_TO_STATE.ACTION_CODE.PHONG_HOP.TU_CHOI:
          // this.rules.startTime = [];
          // this.rules.endTime = [];
          this.rules.roomId = [];
          // this.rules.note = [defaultRequiredConstrains];
          break;
        default:
          // this.rules.startTime = [defaultRequiredConstrains];
          // this.rules.endTime = [defaultRequiredConstrains];
          this.rules.roomId = [defaultRequiredConstrains];
          // this.rules.note = [defaultRequiredConstrains];
          break;
      }
    },

    loadFreeRooms(startTime, endTime) {
      return hcCfgMeetingRoomService
        .findAllFreeRooms(
          this.hcFlow.deptId,
          startTime,
          endTime,
          this.hcCasePhonghop.roomId ? [this.hcCasePhonghop.roomId] : null,
          { sort: "roomName,asc" }
        )
        .then((response) => {
          if (
            response.data.filter(
              (item) => item.id === this.hcCasePhonghop.roomId
            ).length ||
            !this.hcCasePhonghop.meetingRoomId ||
            !this.hcCasePhonghop.meetingRoomName
          ) {
            this.listRooms = response.data;
          } else {
            this.listRooms = response.data.concat({
              id: this.hcCasePhonghop.meetingRoomId,
              roomName: this.hcCasePhonghop.meetingRoomName,
            });
          }
        });
    },

    getActorLabel(userDeptRoleView) {
      return utils.buildUserDeptRoleViewLabel(userDeptRoleView);
    },

    loadHcCasePhongHopUsers() {
      return hcCasePhongHopUserService
        .findAllByHcCaseMasterId(this.caseMasterId)
        .then((response) => (this.hcCasePhongHopUsers = response.data))
        .then(() => {
          let userDeptRoleIds = h.collect(
            this.hcCasePhongHopUsers,
            (item) => item.userDeptRoleId
          );
          return (userDeptRoleIds && userDeptRoleIds.length
            ? userDeptRoleViewService
                .findAllByIdIn(userDeptRoleIds)
                .then((response) => response.data)
            : Promise.resolve(null)
          ).then(
            (involedUsers) =>
              (this.involedUsers =
                involedUsers &&
                involedUsers.sort((item1, item2) =>
                  utils.compareUserDeptRoleView(item1, item2)
                ))
          );
        });
    },

    loadRequestUserDeptRole() {
      return userDeptRoleViewService
        .findRequesterForHc(this.caseMasterId)
        .then((response) => (this.requestUserDeptRole = response.data));
    },

    initFormForEdit() {
      this.bindDataToForm(this.form);
    },

    bindDataToForm(form) {
      form.meetingTitle = this.hcCasePhonghop.meetingTitle;
      form.meetingContent = this.hcCasePhonghop.meetingContent;
      form.startTime = this.hcCasePhonghop.startTime
        ? new Date(this.hcCasePhonghop.startTime)
        : null;
      form.endTime = this.hcCasePhonghop.endTime
        ? new Date(this.hcCasePhonghop.endTime)
        : null;
      form.otherInvolved = this.hcCasePhonghop.otherInvolved;
      form.criticalLevel = this.hcCasePhonghop.criticalLevel;
      form.services = (this.hcCasePhonghop.services || "").split(",");
      form.note = this.hcCasePhonghop.note;
      form.involedUserIds = h.collect(this.involedUsers, (item) => item.id);
      form.roomId = this.hcCasePhonghop.roomId;
      form.involedUserIds = h.collect(
        this.hcCasePhongHopUsers,
        (item) => item.userDeptRoleId
      );
      form.roomId = this.hcCasePhonghop.roomId;
      form.note = this.hcCasePhonghop.note;
      form.sendSMS = this.hcCasePhonghop.sendSMS;
      form.sendEmail = this.hcCasePhonghop.sendEmail;
    },

    loadHcCasePhongHop() {
      return hcCasePhongHopService
        .findByHcCaseMaster(this.caseMasterId)
        .then((response) => (this.hcCasePhonghop = response.data));
    },

    loadHcCaseMaster() {
      return hcCaseMasterService
        .findById(this.hcCasePhonghop.caseMasterId)
        .then((response) => (this.hcCaseMaster = response.data));
    },

    loadHcFlowInstance() {
      return hcFlowInstanceService
        .findById(this.hcCaseMaster.flowInstanceId)
        .then((response) => (this.hcFlowInstance = response.data));
    },

    loadNextActions() {
      return hcStateToStateService
        .findAllActionsByHcCaseCommands(this.hcCaseMaster.flowInstanceId)
        .then((response) => (this.nextHcStateToStateActions = response.data));
    },

    initSelectOptions() {
      this.serviceOptions = hanhChinhUtils.buildPhongHopServiceOptions();
    },

    afterSubmitSuccess() {
      console.log("afterSubmitSuccess");
      this.notifyMasterForDataChange({});
      this.goBack();
    },

    backListPage() {
      this.goBack();
    },

    getAction() {
      if (this.hcCasePhonghop.hcCaseCalendarId) {
        this.approve = false;
        this.decline = false;
        this.cancel = false;
        this.update = false;
        return Promise.resolve();
      } else {
        return this.isRequester || this.isApprover
          ? hanhchinhService.getAction(this.caseMasterId).then((respone) => {
              this.actions = respone.data.actions;
              this.approve = null;
              this.decline = null;
              this.cancel = null;
              this.update = null;
              respone.data.actions.forEach((item) => {
                if (item.actionCode === "pheduyet") {
                  this.approve = item.actionCode;
                } else if (item.actionCode === "tuchoi") {
                  this.decline = item.actionCode;
                } else if (item.actionCode === "huyyeucau") {
                  this.cancel = item.actionCode;
                } else if (item.actionCode === "capnhat") {
                  this.update = item.actionCode;
                }
              });
            })
          : Promise.resolve();
      }
    },

    validateForm() {
      return utils.validateFormCommon(this.$refs.form, this.$message);
    },

    validateDateRange() {
      return new Promise((resolve) => {
        let endTime = this.form.endTime;
        let startTime = this.form.startTime;
        if (endTime && startTime && endTime.getTime() < startTime.getTime()) {
          this.$message.error(
            errorMessageFilter({ errorCode: "hcPhongHop.invalidTimeRange" })
          );
          return;
        }
        resolve();
      });
    },

    convertToSubmitForm(actionCode) {
      switch (actionCode) {
        case constants.HC_STATE_TO_STATE.ACTION_CODE.PHONG_HOP.TU_CHOI:
          return {
            action: this.decline,
            caseMasterId: this.caseMasterId,
            note: this.form.note,
          };

        case constants.HC_STATE_TO_STATE.ACTION_CODE.PHONG_HOP.HUY:
          return {
            caseMasterId: this.caseMasterId,
            note: this.form.note,
          };

        default:
          return {
            action: this.approve,
            caseMasterId: this.caseMasterId,
            startTime: this.form.startTime.getTime(),
            endTime: this.form.endTime.getTime(),
            roomId: this.form.roomId,
            note: this.form.note,
            sendSMS: this.form.sendSMS,
            sendEmail: this.form.sendEmail,
            meetingContent: this.form.meetingContent,
          };
      }
    },

    approveRequest() {
      let actionCode =
        constants.HC_STATE_TO_STATE.ACTION_CODE.PHONG_HOP.PHE_DUYET;
      this.$refs.form.clearValidate();
      this.initValidationRules(actionCode);
      this.$nextTick(() => {
        return this.validateForm()
          .then(() => this.validateDateRange())
          .then(() => {
            return hanhchinhService
              .approve(this.convertToSubmitForm(actionCode))
              .then(() => {
                this.$message.success(
                  errorMessageFilter({
                    errorCode: "hcPhongHop.approveSuccess",
                  })
                );
                this.afterSubmitSuccess();
              })
              .catch((error) => {
                this.commonHandleRequestError(error);
                throw error;
              });
          });
      });
    },

    declineRequest() {
      let actionCode =
        constants.HC_STATE_TO_STATE.ACTION_CODE.PHONG_HOP.TU_CHOI;
      this.$refs.form.clearValidate();
      this.initValidationRules(actionCode);
      this.$nextTick(() => {
        return this.validateForm()
          .then(() =>
            utils.confirm(
              this.$confirm,
              errorMessageFilter({ errorCode: "hcPhongHop.decline.confirm" })
            )
          )
          .then(() => {
            return hanhchinhService
              .approve(this.convertToSubmitForm(actionCode))
              .then(() => {
                this.$message.success(
                  errorMessageFilter({
                    errorCode: "hcPhongHop.declineSuccess",
                  })
                );
                this.afterSubmitSuccess();
              })
              .catch((error) => {
                this.commonHandleRequestError(error);
                throw error;
              });
          });
      });
    },

    cancelRequest() {
      let actionCode = constants.HC_STATE_TO_STATE.ACTION_CODE.PHONG_HOP.HUY;
      this.$refs.form.clearValidate();
      this.initValidationRules(actionCode);
      this.$nextTick(() => {
        return this.validateForm()
          .then(() =>
            utils.confirm(
              this.$confirm,
              errorMessageFilter({ errorCode: "hcPhongHop.cancel.confirm" })
            )
          )
          .then(() => {
            return hanhchinhService
              .cancel(this.convertToSubmitForm(actionCode))
              .then(() => {
                this.$message.success(
                  errorMessageFilter({
                    errorCode: "hcPhongHop.cancelSuccess",
                  })
                );
                this.afterSubmitSuccess();
              })
              .catch((error) => {
                this.commonHandleRequestError(error);
                throw error;
              });
          });
      });
    },

    updateRoom() {
      let actionCode =
        constants.HC_STATE_TO_STATE.ACTION_CODE.PHONG_HOP.CAP_NHAT;
      this.$refs.form.clearValidate();
      this.initValidationRules(actionCode);
      this.$nextTick(() => {
        return this.validateForm()
          .then(() => this.validateDateRange())
          .then(() =>
            utils.confirm(
              this.$confirm,
              errorMessageFilter({ errorCode: "hcPhongHop.update.confirm" })
            )
          )
          .then(() => {
            return hanhchinhService
              .updateRoom(this.convertToSubmitForm(actionCode))
              .then(() => {
                this.$message.success(
                  errorMessageFilter({
                    errorCode: "hcPhongHop.updateSuccess",
                  })
                );
                this.afterSubmitSuccess();
              })
              .catch((error) => {
                this.commonHandleRequestError(error);
                throw error;
              });
          });
      });
    },
  },
};
</script>
<style scoped>
span.readonly-field {
  color: var(--color-black) !important;
  font-size: inherit;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/phonghop/hc-phonghop-detail.vue